import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IMonedaResponse } from '../interfaces/moneda.interface';

@Injectable({
  providedIn: 'root'
})
export class MonedaService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}CampoTablaWhere/GetMonedas`;

  constructor(private http: HttpClient) { }

  getMonedas(): Observable<IMonedaResponse> {
    return this.http.post<IMonedaResponse>(this.API_URL, {});
  }
} 